export function readEmailFromLocalStorage(): string | null {
  try {
    const raw = window.localStorage.getItem('authUserSub');
    if (!raw) return null;
    return JSON.parse(raw)?.email ?? null;
  } catch {
    return null;
  }
}
